import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./OpalAddRemarksModal.css";

const OpalAddRemarksModal = ({ show, onHide, display, onUpdate }) => {
    const [remarks, setRemarks] = useState("");

    useEffect(() => {
        setRemarks(display || ''); // Update remarks when display changes
    }, [display]);

    const handleRemarks = (e) => {
        setRemarks(e.target.value);
    };

    const handleUpdate = () => {
        onUpdate(remarks); // Pass remarks value on update
        onHide();
    };

    return (
        <Modal className="opal-add-remarks-modal" show={show} onHide={onHide} centered>
            <Modal.Header>
                Add Remarks
            </Modal.Header>
            <Modal.Body>
                <div className="input-group">
                    <textarea
                        className="form-control"
                        placeholder="Type to input your Remarks"
                        value={remarks}
                        onChange={handleRemarks}
                        rows="4"
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="update-btn" onClick={handleUpdate}>
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default OpalAddRemarksModal;
